<p-toast />

<div class="flex items-center justify-center min-h-screen bg-gray-50 p-4">
  <p-card class="max-w-2xl w-full shadow-lg">
    <ng-template pTemplate="header">
      <div class="flex flex-col items-center pt-8 pb-4">
        <!-- Warning Icon -->
        <div class="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
        </div>
        <h2 class="text-2xl font-bold text-gray-800">Subscription Inactive</h2>
      </div>
    </ng-template>

    <div class="text-center space-y-6 px-6 py-4">
      <!-- Main Message -->
      <div class="bg-orange-50 border border-orange-200 rounded-lg p-4">
        <p class="text-gray-700 text-lg">
          {{ message }}
        </p>
      </div>

      <!-- Additional Information -->
      <div class="text-left space-y-3">
        <h3 class="font-semibold text-gray-800 text-lg">What does this mean?</h3>
        <ul class="list-disc list-inside space-y-2 text-gray-600">
          <li>Your organization's subscription has expired or is inactive</li>
          <li>You won't be able to access the system until the subscription is renewed</li>
          <li>Please contact your System Administrator to renew the subscription</li>
        </ul>
      </div>

      <!-- Who to Contact -->
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 text-left">
        <h3 class="font-semibold text-blue-900 mb-2 flex items-center">
          <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Who can help?
        </h3>
        <p class="text-blue-800 text-sm">
          Contact your <strong>System Administrator (SA)</strong> to renew your organization's subscription and restore access.
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-3 justify-center pt-4">
        <p-button 
          label="Check Subscription Again" 
          icon="pi pi-refresh"
          (onClick)="checkSubscriptionAgain()"
          styleClass="w-full sm:w-auto"
          [loading]="checking"
          [disabled]="checking"
        />
        <p-button 
          label="Contact Support" 
          icon="pi pi-phone"
          (onClick)="contactSupport()"
          styleClass="w-full sm:w-auto"
          severity="secondary"
          [outlined]="true"
        />
        <p-button 
          label="Logout" 
          icon="pi pi-sign-out"
          (onClick)="logout()"
          styleClass="w-full sm:w-auto"
          severity="danger"
          [outlined]="true"
        />
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="text-center text-sm text-gray-500 pb-4">
        <p>Need immediate assistance? Contact your system administrator.</p>
      </div>
    </ng-template>
  </p-card>
</div>

